import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetClientRequest, sendPatchClientRequest } from '../../../api/helper';

export const getLanguage = createAsyncThunk('multilingual/getLanguage', async ({ limit, page, search }) => {
  let response;
  if (search) {
    response = await sendGetClientRequest(`/api/multilingual?limit=${limit}&page=${page}&search=${search}`);
  } else {
    response = await sendGetClientRequest(`/api/multilingual?limit=${limit}&page=${page}`);
  }
  return response.data;
});

export const updateLanguage = createAsyncThunk('multilingual/updateLanguage', async (parameters) => {
  const response = await sendPatchClientRequest(`/api/multilingual/${parameters.id}`, parameters);
  return response;
});

export const getListsLanguage = createAsyncThunk('multilingual/getListsLanguage', async () => {
  const response = await sendGetClientRequest(`/api/multilingual_list`);
  return response;
});

const multilingualSlice = createSlice({
  name: 'multilingual',
  initialState: {
    lists: [],
    language: [],
    loading: false,
  },
  reducers: {
    removeSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: {
    // GET LANGUAGE
    [getLanguage.pending]: (state) => {
      state.loading = true;
    },
    [getLanguage.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.language = payload;
        state.loading = false;
      }
    },
    [getLanguage.rejected]: (state) => {
      state.loading = false;
    },

    // GET LANGUAGE LIST ACTIVE
    [getListsLanguage.pending]: (state) => {
      state.loading = true;
    },
    [getListsLanguage.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.lists = payload;
        state.loading = false;
      }
    },
    [getListsLanguage.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default multilingualSlice.reducer;
export const selectMultilingual = (state) => state.multilingual;
export const { removeSuccess } = multilingualSlice.actions;
